export default [
    {
        path: '/sales',
        name: 'SalesActionsIndex',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Sales',
            fullHeight: true,
        },
        components: {
            default: () => import('@views/sales/SalesActionsIndex.vue'),
        },
    },
];
